import React from "react"
import { Grid, InputLabel, FormControl, Select, Checkbox, ListItemText, FormHelperText, MenuItem } from "@material-ui/core"
import { KeyboardArrowDown } from "@material-ui/icons"
import { useTranslation } from "react-i18next"

import useStyles from "./styles"

function AssigntoMultiSelect({ data }) {
	const { SkeletonList, formik, assignmentDetails, MenuProps, isUsersListLoading, usersList, userListItems, isAssigmentDone } = data

	const classes = useStyles()
	const [t] = useTranslation("global")

	const getAssigneeList = (assigneeIds) => {
		let assigneeList = []
		if (assigneeIds?.length > 0) {
			for (let i = 0; i < assigneeIds?.length; i++) {
				if (usersList?.length > 0) {
					const found = usersList.filter((user) => user?.user_id === assigneeIds[i])
					found?.[0]?.username ? assigneeList.push(found?.[0]?.username) : ""
				}
			}
		}
		return assigneeList
	}

	return (
		<Grid item xs={12}>
			<FormControl fullWidth variant="outlined">
				<InputLabel id="assignToInputLable">{t("review.reviewForm.assignTo")}</InputLabel>
				<Select
					id="users"
					name="users"
					labelId="assignToInputLable"
					variant="outlined"
					value={formik.values.users}
					onChange={(selectedOption) => {
						formik.handleChange(selectedOption)
					}}
					onBlur={() => {
						formik?.setFieldTouched("users", true)
					}}
					displayEmpty
					className={`${classes.autoSelect} ${classes.formField}`}
					MenuProps={MenuProps}
					multiple
					renderValue={(selected) => {
						const selectedAssignee = getAssigneeList(selected)
						return selectedAssignee?.join(", ")
					}}
					IconComponent={KeyboardArrowDown}
					placeholder={t("review.reviewForm.assigntoLabel")}
				>
					{isUsersListLoading ? (
						<SkeletonList />
					) : usersList.length ? (
						usersList?.map((user) => (
							<MenuItem key={user?.user_id} value={user?.user_id} className={classes?.menuItemStyle}>
								<Checkbox checked={formik?.values?.users?.indexOf(user?.user_id) > -1} />
								<ListItemText primary={user?.username} />
							</MenuItem>
						))
					) : (
						<MenuItem value="">
							<em>{t("review.noDataFound")}</em>
						</MenuItem>
					)}
				</Select>
			</FormControl>
		</Grid>
	)
}

export default AssigntoMultiSelect
